// import { Link } from "react-router-dom";
import styles from "./TestimonialsCard.module.scss";
// import { Icon } from "components/icons/Icon";
import { Star, StarFill } from 'react-bootstrap-icons';

const ratingDisplay = (rating) => {
  const ratings = []
  for (let i = 1; i <= 5; i++) {
    if (rating < i) {
      ratings.push(<Star color="orange"/>)
    } else {
      ratings.push(<StarFill color="orange"/>)
    }
  }
  return ratings
}

const TestimonialsCard = ({ className, name, description, rating, img }) => {
  return (
    <div className={[className, styles.card, "testimonials-card"].join(" ")}>
      <div className={styles.icon}>
        {/* <i className={`uil uil-user-arrows`} /> */}
        <img src={img} alt=""/>
        {/* <Person className="testimonials-card-icon" color="orange" size="fit-content"/> */}
      </div>
      <div className={styles.contents}>
        <h3 className={styles.name}>{name}</h3>
        <p className={[styles.description, "text-muted"].join(" ")}>{description}</p>
        {ratingDisplay(rating)}
      </div>
    </div>
  );
};

export default TestimonialsCard;
